import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'lademenge/einwohner',
  label: 'Lademenge pro Einwohner',
  positiveDirection: PositiveDirection.custom,
  valueFormat: '-#.###.##0,00',
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
